import { render, staticRenderFns } from "./ResearchResults.vue?vue&type=template&id=0d8d4764&scoped=true&"
import script from "./ResearchResults.vue?vue&type=script&lang=js&"
export * from "./ResearchResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8d4764",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d8d4764')) {
      api.createRecord('0d8d4764', component.options)
    } else {
      api.reload('0d8d4764', component.options)
    }
    module.hot.accept("./ResearchResults.vue?vue&type=template&id=0d8d4764&scoped=true&", function () {
      api.rerender('0d8d4764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/landing-page/components/research/ResearchResults.vue"
export default component.exports